// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"db21f3e1","403":"8e8e6b1b"}[chunkId] + ".chunk.css";
};